import { OnInit } from '@angular/core';
import { ScaleResult } from 'app/shared/models/scale-result';
var ScaleRangeContentComponent = /** @class */ (function () {
    function ScaleRangeContentComponent() {
        this.client = false;
    }
    ScaleRangeContentComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(ScaleRangeContentComponent.prototype, "hasContent", {
        get: function () {
            if (this.scaleResult && this.scaleResult.range) {
                if (this.client && this.scaleResult.range.clientContent) {
                    return this.scaleResult.range.clientContent.trim() != "";
                }
                else if (this.scaleResult.range.therapistContent) {
                    return this.scaleResult.range.therapistContent.trim() != "";
                }
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    ScaleRangeContentComponent.prototype.shouldShowContent = function (scaleResult) {
        return this.expandContent && this.hasContent;
    };
    return ScaleRangeContentComponent;
}());
export { ScaleRangeContentComponent };



// WEBPACK FOOTER //
// ./src/app/reports/scale-range-content/scale-range-content.component.ts.pre-build-optimizer.js